const config = {
    APP_NAME: '4Sport Padel Ejea',
    TITLE_SEPARATION: ' - ',
    BLOG_TITLE: '4Sport Padel Ejea',
    ADMIN_TITLE_NAME: '4Sport Admin'
};

export default config;